<template>
  <div>
    <div class="d-flex justify-space-between bg-darkblue px-3 py-2 rounded-t shadowed mt-1">
      <div class="">Commande n°{{ commande.uuid }} - le {{ $moment(commande.timestamp).format("DD/MM/YYYY à HH:mm") }}</div>
    </div>

    <div class="rounded-b mb-3">
      <ActionsCardCommande :item="commande"></ActionsCardCommande>
      <CommandeInscriptionItem v-for="item in commande.list_commandes_inscriptions_coureur" :item="item" :key="item.id"></CommandeInscriptionItem>
    </div>
  </div>
</template>

<script>
import CommandeInscriptionItem from "./Commande_Inscription_Item.vue";
import ActionsCardCommande from "./Actions_Card_Commande.vue";
export default {
  components: {
    ActionsCardCommande,
    CommandeInscriptionItem,
  },

  data() {
    return {
      commande: {},
    };
  },
  props: ["item"],
  created() {
    this.commande = this.item;
  },
};
</script>

<style lang="scss" scoped>
</style>